// extracted by mini-css-extract-plugin
module.exports = {"Loader_block":"Loader_Loader_block__1-GYG","lds_ripple":"Loader_lds_ripple__1SQI-"};